import { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { GET_DUR_MEDICATIONS } from 'gql'
import type { FuzzySearchProps } from 'modals/DurInputMappingsModal/types'
import type { DURSubject } from 'types'
import FuzzySearchAutoComplete from './FuzzySearchAutocomplete'

const MedicationsFuzzySearch = (props: FuzzySearchProps) => {
  const { searchTerm } = props
  const [newSearchTerm, setNewSearchTerm] = useState(searchTerm)
  const { data, error } = useQuery<{ getMedications: DURSubject[] }>(GET_DUR_MEDICATIONS, {
    skip: !newSearchTerm,
    variables: { medications: newSearchTerm },
  })

  useEffect(() => {
    setNewSearchTerm(searchTerm)
  }, [searchTerm])

  return (
    <FuzzySearchAutoComplete
      {...props}
      suggestions={data?.getMedications ?? []}
      error={error}
      searchTerm={newSearchTerm}
      onChange={setNewSearchTerm}
    />
  )
}

export default MedicationsFuzzySearch
